import { requireNotificationsAccess, requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Home } from 'lucide-react';
import { NotificationsContent } from '../../../features/notifications/components';
import { Page, PageHeader } from '../../../shared/ui/page';

export const Route = createFileRoute('/_app/notifications/')({
  component: RouteComponent,
  beforeLoad: async () => {
    // Dois gates: a permissão é a mesma das apólices (toda notificação de hoje
    // leva a uma), e o grupo restringe a tela a quem tem feed — corretora e
    // seguradora.
    const [hasPermission, hasNotificationsAccess] = await Promise.all([
      requirePermissions(['policies.emissions.read']),
      requireNotificationsAccess(),
    ]);

    if (!hasPermission || !hasNotificationsAccess) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          {
            label: 'Pagina Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Notificações', active: true },
        ]}
      />

      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>Notificações</PageHeader.Title>
            <PageHeader.Subtitle>
              Acompanhe os avisos das apólices e propostas
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>

      <NotificationsContent />
    </Page.Root>
  );
}
